/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/require-default-props */

import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DEPOSIT_AMOUNT from 'constants/salon/depositAmount.const';

import CN from './DepositModal.module.scss';

class DepositModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ncob_custom_amount: this.props.ncob_custom_amount || 0,
      ncob_deposit_settings: this.props.ncob_deposit_settings || DEPOSIT_AMOUNT.full,
    };
  }

  handleSave = () => {
    const data = {
      ncob_deposit_settings: this.state.ncob_deposit_settings,
      ncob_custom_amount: parseFloat(this.state.ncob_custom_amount),
      no_show_protection: false,
    };
    this.props.onSave(data);
  };

  handleChangeAmount = (value) => void this.setState({ ncob_custom_amount: parseFloat(value) });

  handleRadioChange = (value) => {
    this.setState({
      ncob_deposit_settings: value,
    });
    if (value !== 'custom_amount') {
      this.setState({ ncob_custom_amount: 0 });
    }
  };

  render() {
    const { full, half, custom } = DEPOSIT_AMOUNT;

    const { ncob_deposit_settings, ncob_custom_amount } = this.state;

    const isFullOrHalf = ncob_deposit_settings === full || ncob_deposit_settings === half;
    const amountEmpty = !ncob_custom_amount && ncob_deposit_settings === custom;

    const isDisabled = !isFullOrHalf && amountEmpty;

    return (
      <SalonModal tag="ModalDepositAmount" isOpen>
        <SalonModal.Header>
          <div className={CN.closeButtonContainer}>
            <Button variant="empty" onClick={this.props.onClose}>
              <Icon variant="close" variantInvert />
            </Button>
          </div>
        </SalonModal.Header>
        <SalonModal.Body>
          <div className={CN.modalImage}>
            <div className={CN.iconContainer}>
              <Icon variant="currency" variantInvertDark />
            </div>
          </div>
          <div className={CN.modalContent}>
            <div className={CN.modalTitle}>
              Set a deposit amount (upfront cost) for
              <br />
              when clients book online
            </div>

            <div className={CN.modalText}>
              <div className="modal-body">
                <div className="modal-content">
                  <div className="pay-options">
                    <div className="row radio-group as-checkbox">
                      <div className={CN.selectOptionContainer}>
                        <label className="radio-btn" htmlFor="full_amount">
                          <input
                            id="full_amount"
                            value="full_amount"
                            name="full_amount"
                            type="radio"
                            checked={this.state.ncob_deposit_settings === full}
                            onChange={(e) => this.handleRadioChange(e.target.value)}
                          />
                          <span className="checkmark" />
                          <div className={CN.label}>100% of the booking price</div>
                        </label>
                      </div>
                      <div className={CN.selectOptionContainer}>
                        <label className="radio-btn" htmlFor="half_amount">
                          <input
                            id="half_amount"
                            value="half_amount"
                            name="half_amount"
                            type="radio"
                            checked={this.state.ncob_deposit_settings === half}
                            onChange={(e) => this.handleRadioChange(e.target.value)}
                          />
                          <span className="checkmark" />
                          <div className={CN.label}>50% of the booking price</div>
                        </label>
                      </div>
                      <div className={CN.selectOptionContainer}>
                        <div className="radio-plus-input">
                          <div className={CN.customOption}>
                            <label className="radio-btn" htmlFor="custom_amount">
                              <input
                                id="custom_amount"
                                value="custom_amount"
                                name="custom_amount"
                                type="radio"
                                checked={this.state.ncob_deposit_settings === custom}
                                onChange={(e) => this.handleRadioChange(e.target.value)}
                              />
                              <span className="checkmark" />
                              <div className={CN.label}>
                                Custom amount (<CurrencySign />)
                              </div>
                            </label>
                            <input
                              type="number"
                              step="any"
                              className="deposit-amount"
                              name="ncob_custom_amount"
                              value={this.state.ncob_custom_amount}
                              onChange={(e) => this.handleChangeAmount(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SalonModal.Body>
        <SalonModal.Footer>
          <Button variant="primaryForce" onClick={this.handleSave} disabled={isDisabled}>
            <span className={CN.buttonSpace}>SET DEPOSIT</span>
          </Button>
        </SalonModal.Footer>
      </SalonModal>
    );
  }
}

export default DepositModal;
